'use strict';

class List extends Widget {
  _element: any;
  _items: any;
  _index: any;

  constructor(element: any) {
    super(element);
    this._items = [];
    this._index = 0;

    this.__defineGetter__('length', () => {
      return this._items.length;
    });
  }

  append(item: any) {
    if (!(item instanceof Widget)) {
      throw new Error('List.append expects a ui.Widget');
    }

    if (!(item instanceof ListItem)) {
      let listitem = ui.listitem();
      listitem.append(item);
      item = listitem;
    }

    let index = this._items.length;
    item.on('clicked', this._onItemClicked.bind(this, index));
    item.on('doubleclicked', this._onItemDoubleClicked.bind(this, index));

    this._items.push(item);
    this._element.append(item._element);
    return item;
  }

  erase(index: any) {
    this._items[index].remove();
    this._items.splice(index, 1);

    if (this._index >= this._items.length) {
      this.index(this._items.length - 1);
    }
  }

  index(index?: any, noClick?: any) {
    if (index === undefined) {
      return this._index;
    } else {
      this._index = index;

      if (index >= this._items.length) {
        index = this._items.length;
      }

      if (this._items.length === 0) {
        index = -1;
      }

      for (let i = 0; i < this._items.length; ++i) {
        this._items[i].selected(i === index);
      }

      if (!noClick) {
        if (index === -1) {
          this.emit('itemclicked', index);
        } else {
          this._items[index].click();
        }
      }
    }
  }

  clear() {
    this._items = [];
    this._index = -1;
    this._element.html('');
  }

  _onItemClicked(index: any) {
    this.index(index, true);
    this.emit('itemclicked', index);
  }

  _onItemDoubleClicked(index: any) {
    this.index(index, true);
    this.emit('itemdoubleclicked', index);
  }

  static Create() {
    return $('<div class="list" />');
  }
}

class ListItem extends Widget {
  _element: any;

  constructor(parent: any, element: any) {
    super(parent || element);
    this._element.click(this._onClicked.bind(this));
    this._element.dblclick(this._onDoubleClicked.bind(this));
    // iOS doesn't reliably fire dblclick for touch, so a second quick tap counts as one.
    // Desktop is untouched: mouse input only gets the native dblclick.
    let lastTap = 0;
    this._element.on('pointerup', (e: any) => {
      if (e.originalEvent.pointerType !== 'touch') return;
      const now = Date.now();
      if (now - lastTap < 350) {
        lastTap = 0;
        this._onDoubleClicked();
      } else {
        lastTap = now;
      }
    });
  }

  click() {
    this._onClicked();
  }

  text(text: any) {
    this._element.text(text);
  }

  html(html: any) {
    this._element.html(html);
  }

  selected(selected?: any) {
    if (selected === undefined) {
      return this._element.hasClass('selected');
    } else if (selected !== this.selected()){
      this._element.toggleClass('selected');
    }
  }

  _onClicked() {
    this.emit('clicked');
  }

  _lastDouble = 0;

  _onDoubleClicked() {
    // The tap fallback and a native dblclick can both fire for one gesture.
    const now = Date.now();
    if (now - this._lastDouble < 500) return;
    this._lastDouble = now;
    this.emit('doubleclicked');
  }

  static Create() {
    return $('<div class="listitem" />');
  }
}

ui.List = List;
ui.ListItem = ListItem;
ui.list = ui.widgetConstructor('list', ui.List);
ui.listitem = ui.widgetConstructor('listitem', ui.ListItem);
